import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import * as React from 'react';
import { useMiaSelector } from './hooks';
import { SMDialogContent } from './SMDialogContent';

interface ISpinnerDialogProps {}

let SpinnerDialog: React.ComponentType<ISpinnerDialogProps> = () => {
  const message = useMiaSelector(state => state.ui.spinnerDialogMessage);

  return Boolean(message) ? (
    <Dialog open disableBackdropClick disableEscapeKeyDown>
      <DialogTitle>Please Wait</DialogTitle>
      <SMDialogContent disableOverflow>
        <Grid container justify="space-between" alignItems="center" spacing={3}>
          <Grid item xs={3}>
            <CircularProgress size="100%" />
          </Grid>
          <Grid item xs={9}>
            <Typography variant="subtitle1">{message}</Typography>
          </Grid>
        </Grid>
      </SMDialogContent>
    </Dialog>
  ) : null;
};

SpinnerDialog = React.memo<ISpinnerDialogProps>(SpinnerDialog);
export { SpinnerDialog };
